import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from "../store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/404',
        name: 'error',
        component: () => import('../components/error.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '*',
        redirect: {name: 'error'},
        meta: { requiresAuth: false }
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/usuarios/login.vue'),
        meta: { requiresVisitor: true }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/perfil',
        name: 'MiPerfil',
        component: () => import('../views/MiPerfil.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/cambiar-password',
        name: 'CambiarPassword',
        component: () => import('../views/CambiarPassword.vue'),
        meta: { requiresAuth: true }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        if (store.getters.isLogin)
            next()
        else
            next({path: '/login'})
    } else
        next()
});


export default router
